import { POST_RESERVATION_DATA } from '../constants/actionTypes'

const reservationCreation = (store = [], action = {}) => {
  if(action.type === POST_RESERVATION_DATA){
    return action.data
  }
  else{
    return store
  }
}

export default reservationCreation
